export function insertIf<T>(condition: boolean, ...elements: T[]) {
    return condition ? elements : [];
}
